import Vue from "vue"
import Vuetify from "vuetify/lib"

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#145e65",//#0D5775
        secondary: "#651b14",
        accent: "#5e6514",
        error: "#f44336",
        info: "#2196f3",
        success: "#4caf50",
        warning: "#ff9800",
      }
    },
  },
})
